(function () {
    'use strict';

    angular
        .module('app.campaignAdvertiserManagePage')
        .factory('campaignAdvertiserManagePageService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes));
                            }
                        })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getCampaignsForCompany(company_id, loader) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getCampaignsForCompany/' + company_id, 'GET', null, loader);
                }

                function getInfluencersForCampaign(campaign_id, loader) {
                    return handleRequest($rootScope.apiUrl + 'campaign/getAggregatedDataForCampaign/' + campaign_id, 'GET', null, loader);
                }

                function deleteCampaign(campaign_id, loader) {
                    var url_deleteCampaign = $rootScope.apiUrl + 'campaign/deleteCampaign/' + campaign_id;
                    return handleRequest(url_deleteCampaign, 'DELETE', null, loader);
                }

                service.getCampaignsForCompany = getCampaignsForCompany;
                service.getInfluencersForCampaign = getInfluencersForCampaign;
                service.deleteCampaign = deleteCampaign;

                return service;
            }
        ]);
})();
